
import Vue from 'vue';
import Component from 'vue-class-component';
import NodeFormMixin from '../forms/NodeFormMixin';

@Component({
  name: 'MailingSummary',
})
export default class MailingSummary extends NodeFormMixin {}
